const handler = ( $ ) => {
	$( '#ajax-load-more' ).on( 'click', function ( e ) {
		e.preventDefault();

		const $link = $( '#ajax-load-more' ),
			$postsHolder = $( $link.data( 'posts-holder' ) );
		const offset = $postsHolder.find( 'article' ).length;

		$.ajax( {
			url: themeVars.ajaxurl,
			type: 'POST',
			dataType: 'json',
			data: {
				action: 'ajax_load_posts',
				query: $link.attr( 'data-current-query' ),
				post_type: $link.attr( 'data-post-type' ),
				offset,
				nonce: themeVars.ajaxLoadMoreNonce || '',
			},
			beforeSend() {
				$postsHolder.addClass( 'is-loading' );
			},
			success( answer ) {
				$postsHolder.removeClass( 'is-loading' ).append( answer.html );

				$link.attr(
					'data-current-query',
					JSON.stringify( answer.query )
				);

				if ( answer.hide_link ) {
					$link.hide();
				} else {
					$link.show();
				}
			},
		} );
	} );
};

export default ( ( $ ) => $( handler ) )( jQuery );
